export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9543.be8af062.jpg";